<template>
  <div>
    <label>▼プレビュー</label>
    <div class="p-markdown">
      <div class="markdown-body">
        <p v-html="preview"></p>
        <p>{{ convertTextToHTML(content) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'MarkdownPreview',
  props: {
    content: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      preview: ''
    }
  },
  created () {
    axios.defaults.headers.common = {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute('content')
    }
  },
  methods: {
    convertTextToHTML (textContent) {
      if (!textContent) {
        this.preview = ''
        return
      }
      axios.post('/api/markdown_previews', {
        markdown_text: textContent
      }).then(response => {
        this.preview = response.data
      }).catch(error => {
        console.error('Error:', error)
        alert('Markdownのプレビューに失敗しました: ' + error.message)
      })
    }
  }
}
</script>
